/**
 * Helpers de sobreposições para o Dashboard Executivo
 */

const ensureArray = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
};

const countTemaItems = (sobreposicaoArray, temaKey) => {
  if (!Array.isArray(sobreposicaoArray) || sobreposicaoArray.length === 0) {
    return 0;
  }

  let total = 0;

  sobreposicaoArray.forEach((item) => {
    const temas = item?.temas || {};
    const raw = temas[temaKey];

    if (!raw) return;

    const arr = ensureArray(raw);
    arr.forEach((entry) => {
      if (entry) {
        total += 1;
      }
    });
  });

  return total;
};

const makeStatus = (label, count, overColor) => {
  // Regra do usuário: count > 1 => warning/error conforme tema; caso contrário, default
  let color = 'default';
  if (count > 1) {
    color = overColor;
  }

  const hasOverlap = count > 0;

  return {
    label,
    color,
    count,
    hasOverlap,
  };
};

export function getSobreposicoesDashboardStatus(data) {
  const properties = data?.properties || {};
  const sobreposicaoRaw = properties.sobreposicao;

  const sobreposicaoArray = Array.isArray(sobreposicaoRaw)
    ? sobreposicaoRaw
    : sobreposicaoRaw
      ? [sobreposicaoRaw]
      : [];

  const ucCount = countTemaItems(sobreposicaoArray, 'uc');
  const florestasCount = countTemaItems(sobreposicaoArray, 'florestas');
  const aldeiasCount = countTemaItems(sobreposicaoArray, 'aldeias');
  const quilombolasCount = countTemaItems(sobreposicaoArray, 'quilombolas');
  const assentamentosCount = countTemaItems(sobreposicaoArray, 'assentamentos');
  const terrasIndigenasCount = countTemaItems(sobreposicaoArray, 'terras_indigenas');
  const mineracaoCount = countTemaItems(sobreposicaoArray, 'mineracao');
  const embargosIbamaCount = countTemaItems(sobreposicaoArray, 'embargos_ibama');
  const praCount = countTemaItems(sobreposicaoArray, 'pra');

  return {
    uc: makeStatus('Unidade de Conservação', ucCount, 'warning'),
    florestasPublicas: makeStatus('Florestas Públicas', florestasCount, 'warning'),
    aldeiasIndigenas: makeStatus('Aldeias Indígenas', aldeiasCount, 'warning'),
    quilombolas: makeStatus('Quilombos', quilombolasCount, 'warning'),
    assentamentosIncra: makeStatus('Assentamentos INCRA', assentamentosCount, 'warning'),
    terrasIndigenas: makeStatus('Terras Indígenas', terrasIndigenasCount, 'warning'),
    mineracao: makeStatus('Mineração', mineracaoCount, 'warning'),
    embargosIbama: makeStatus('Embargos IBAMA', embargosIbamaCount, 'error'),
    pra: makeStatus('PRA', praCount, 'warning'),
    // Rios, Massa d b4 c1gua e Curso d b4 c1gua dependerão de paths de dados definitivos
  };
}
